import React from 'react';
import moment from 'moment';
import { styled } from '@mui/material';

import { Box, DatePicker, FormLabel, MenuItem, RichTextArea, Select, Tag, Text, TextInput } from 'shell/components';
import { TASK_WORKLOAD_OPTIONS } from 'utils/constants';

const TemplateSubtaskView = ({ subtask, changes, updateSubtask }) => {
    subtask = { ...subtask, ...(changes.subtasks || []).find(({ id }) => id === subtask.id) };

    const workloadOptions = TASK_WORKLOAD_OPTIONS.map((option) => ({
        key: option.value,
        value: <Tag sx={{ width: '100%' }} type={'workload'} value={option.value} />,
    }));

    return (
        <>
            <TitleTextInput
                id={'template-subtask-title'}
                placeholder={'Write a subtask title...'}
                value={subtask.title || ''}
                onChange={(e) => updateSubtask('title', e.target.value)}
            />
            <TaskInfoBox>
                <CustomFormLabel htmlFor={'template-subtask-workload'}>
                    <Text variant={'p2'} weight={'semibold'}>
                        Workload
                    </Text>
                </CustomFormLabel>
                <CustomSelect
                    inputProps={{ id: 'template-subtask-workload' }}
                    renderValue={(selected) => {
                        return workloadOptions.find(({ key }) => key === selected).value;
                    }}
                    value={subtask.workload}
                    onChange={(e) => updateSubtask('workload', e.target.value)}
                >
                    {workloadOptions.map(({ key, value }) => (
                        <MenuItem key={key} value={key}>
                            {value}
                        </MenuItem>
                    ))}
                </CustomSelect>
                <CustomFormLabel htmlFor={'template-subtask-datepicker'}>
                    <Text variant={'p2'} weight={'semibold'}>
                        Due Date
                    </Text>
                </CustomFormLabel>
                <CustomDatePicker
                    id={'template-subtask-datepicker'}
                    value={(subtask.end_on && moment(subtask.end_on)) || moment()}
                    onChange={(timestamp) => updateSubtask('end_on', timestamp.valueOf())}
                />
                <FormLabel sx={{ mt: '10px' }} htmlFor={'template-subtask-description'}>
                    <Text variant={'p2'} weight={'semibold'}>
                        Details
                    </Text>
                </FormLabel>
                <CustomRichTextArea
                    id={'template-subtask-description'}
                    placeholder={'Enter Task Details'}
                    value={subtask.description || ''}
                    variant={'dynamic'}
                    onChange={(html) => updateSubtask('description', html)}
                />
            </TaskInfoBox>
        </>
    );
};

const TitleTextInput = styled(TextInput)(({ theme }) => {
    return {
        margin: theme.spacing(0, -3),
        width: `calc(100% + ${theme.spacing(6)})`,
        '&& input': {
            fontSize: `${theme.typography.sh1.fontSize.large}rem`,
            fontWeight: theme.typography.sh1.fontWeight.semibold,
            letterSpacing: `${theme.typography.sh1.letterSpacing.large}rem`,
            lineHeight: `${theme.typography.getLineHeight('sh1', 'large')}rem`,
        },
        '& fieldset': {
            border: 'none',
        },
    };
});

const TaskInfoBox = styled(Box)(({ theme }) => {
    return {
        display: 'grid',
        gridTemplateColumns: '5.625rem 1fr',
        gridGap: theme.spacing(1, 0),
        width: '100%',
    };
});

const CustomFormLabel = styled(FormLabel)(() => {
    return {
        alignSelf: 'center',
    };
});

const CustomSelect = styled(Select)(() => {
    return {
        minWidth: 0,
        maxWidth: 'fit-content',
        '& fieldset': {
            border: 'none',
        },
    };
});

const CustomDatePicker = styled(DatePicker)(() => {
    return {
        '& fieldset': {
            border: 'none',
        },
    };
});

const CustomRichTextArea = styled(RichTextArea)(() => {
    return {
        '& .MuiRichTextArea-root': {
            maxHeight: '12rem',
        },
    };
});

export default TemplateSubtaskView;
